import { BatchClient, SubmitJobCommand } from "@aws-sdk/client-batch";
import { getAwardYear } from "../awards/get-award-year.js";
import { getCandidateMetadata } from "./get-candidate-metadata.js";
import { getCandidateInstance } from "./get-candidate-instance.js";
import { getDb } from "../db.js";
import { z } from "zod";
export const autoCategorizeCandidateSchema = z.object({
    candidatePK: z.string({ required_error: "Missing candidatePK" }).min(1),
    awardYear: z.coerce.number().optional(),
    forceScrape: z.boolean().optional(),
});
export async function autoCategorizeCandidate(table, { candidatePK, awardYear, forceScrape }) {
    if (!awardYear) {
        awardYear = await getAwardYear(table);
    }
    const [metadata, instance] = await Promise.all([
        getCandidateMetadata(table, candidatePK),
        getCandidateInstance(table, candidatePK, awardYear),
    ]);
    if (!metadata?.website) {
        throw new Error(`Candidate does not have a website.`);
    }
    const currentStatus = instance?.wingman?.status || "";
    if (["running", "queued"].includes(currentStatus)) {
        throw new Error(`Wingman is already running or queued for ${metadata.name}`);
    }
    const batchClient = new BatchClient({ region: "us-west-2" });
    await batchClient.send(new SubmitJobCommand({
        jobDefinition: "run-categorization-for-candidate",
        jobName: `${table}_${metadata.id}_${new Date().getTime()}`,
        jobQueue: "categorization-job-queue",
        parameters: {
            table,
            award_year: `${awardYear}`,
            candidate_pk: candidatePK,
            force_scrape: (forceScrape ?? false).toString(),
        },
    }));
    const { updateItem } = getDb();
    const wingman = {
        ...(instance?.wingman || {}),
        status: "queued",
    };
    await updateItem({
        TableName: table,
        Key: {
            PK: candidatePK,
            SK: `${awardYear}`,
        },
        UpdateExpression: `
      SET #wingman = :wingman,
          GSI1_PK = :candidatePK,
          GSI1_SK = :INSTANCE`,
        ExpressionAttributeNames: {
            "#wingman": "wingman",
        },
        ExpressionAttributeValues: {
            ":wingman": wingman,
            ":candidatePK": candidatePK,
            ":INSTANCE": `INSTANCE#${awardYear}`,
        },
    });
    return metadata;
}
//# sourceMappingURL=auto-categorize-candidate.js.map